module.exports = __webpack_public_path__ + "static/media/dataManagementCover.a1c6a462.svg";